import { PullQuote as UniformPullQuote } from "@/libraries/design/components";
export type { PullQuoteProps } from "@/libraries/design/components/pull-quote/src/pull-quote";

export default UniformPullQuote;
